// src/lib/pruefpunktInfo.js
// --- ERKLAERUNGEN ZU DEN PRUEFPUNKTEN ("i"-Knopf) -----------------------------
//
// Anna-Lena 13.09.2026: "kleine i's, auf die ich druecken kann, wenn ich wissen
// will, was dahinter steckt - welche Norm, worauf ich achten muss - so dass
// theoretisch ein Laie das Protokoll ausfuellen koennte."
//
// Die Texte stehen in zwei Teilen (Module 01-03 und 04-07) und wurden am
// 13.09.2026 als Arbeitshilfe geschrieben. Sie sind vom Buero gegenzulesen,
// besonders die Normangaben. Schluessel: `${modulCode}|${pos}` - Pos-Nummern
// wie 05.1 gibt es in zwei Modulen (Oelwanne und Sicherheitszubehoer).

import { INFO_TEIL1, MODUL_INFO_TEIL1 } from './pruefpunktInfoTeil1';
import { INFO_TEIL2, MODUL_INFO_TEIL2 } from './pruefpunktInfoTeil2';
import { infoInSprache } from './sprache';

export const PRUEFPUNKT_INFO = { ...INFO_TEIL1, ...INFO_TEIL2 };
export const MODUL_INFO = { ...MODUL_INFO_TEIL1, ...MODUL_INFO_TEIL2 };

// Nur ueber die Pos-Nummer, falls der Modul-Code fehlt - aber nur, wenn es
// die Nummer genau einmal gibt (sonst lieber gar keine als eine falsche Hilfe).
const NACH_POS = {};
for (const [key, wert] of Object.entries(PRUEFPUNKT_INFO)) {
  const pos = key.split('|')[1];
  NACH_POS[pos] = NACH_POS[pos] === undefined ? wert : null;
}

export function infoFuer(modulCode, pos) {
  const p = String(pos || '').trim();
  if (!p) return null;
  // In der gewaehlten Anzeigesprache, sonst deutsch (lib/sprache.js).
  if (modulCode && PRUEFPUNKT_INFO[modulCode + '|' + p]) {
    return infoInSprache(modulCode + '|' + p) || PRUEFPUNKT_INFO[modulCode + '|' + p];
  }
  const deutsch = NACH_POS[p] || null;
  if (!deutsch) return null;
  const key = Object.keys(PRUEFPUNKT_INFO).find(k => PRUEFPUNKT_INFO[k] === deutsch);
  return (key && infoInSprache(key)) || deutsch;
}
